export default "__VITE_ASSET__692777c0__"